import React from 'react';
import { Camera, Check } from 'lucide-react';

export function ExtraCameraSection({ extraCameras, onChange, formatIDR }) {
  return (
    <div 
      className="p-6 border border-border hover:border-primary/50 transition-colors"
      data-testid="extra-camera-section"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className={`p-2 rounded-lg ${extraCameras > 0 ? 'bg-primary/20' : 'bg-muted'}`}>
            <Camera className={`w-6 h-6 ${extraCameras > 0 ? 'text-primary' : 'text-foreground-muted'}`} />
          </div>
          <div>
            <h3 className="text-lg font-heading font-semibold">Extra Camera</h3>
            <p className="text-sm text-foreground-muted">2 4K cameras included in your session</p>
          </div>
        </div>
        
        <label className="flex items-center gap-3 cursor-pointer">
          <span className="text-primary font-semibold">
            {extraCameras > 0 ? `+${formatIDR(300000)}` : formatIDR(300000)}
          </span>
          <button
            type="button"
            onClick={() => onChange(extraCameras === 0 ? 1 : 0)}
            className={`w-12 h-7 rounded-full transition-colors duration-300 relative ${
              extraCameras > 0 ? 'bg-primary' : 'bg-muted'
            }`}
            data-testid="extra-camera-toggle"
          >
            <span 
              className={`absolute top-1 w-5 h-5 rounded-full bg-white transition-transform duration-300 ${
                extraCameras > 0 ? 'translate-x-6' : 'translate-x-1'
              }`}
            />
          </button>
        </label>
      </div>
      
      {extraCameras > 0 && (
        <div className="mt-4 pt-4 border-t border-border">
          <p className="text-sm text-foreground-muted">
            <span className="text-primary font-semibold">3 4K cameras</span> will be available for your session
          </p>
        </div>
      )}
    </div>
  );
}
